import styles from "./PageShell.module.scss";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import BasicInformation from "./BasicInformation";
import AddressDetails from "./AddressDetails";
import JobInformation from "./JobInformation";
import IdVerification from "./IdVerification";
import BankDetails from "./BankDetails";
import EducationDetails from "./EducationDetails";
import PreviousEmploymentDetails from "./PreviousEmploymentDetails";
import DeclarationForm from "./DeclarationForm";
import EsiForm from "./EsiForm";
import SubmissionForm from "./SubmissionForm";
import { responsiveToast } from "../../AppComponent/responsiveToast.js";
// import ReviewPage from "./ReviewPage";
// import udsLogo from "../../assets/udslogo.svg";
import udsLogo from "../../../Assets/udslogo.svg";
import {
  setSignatureEmployeeRetrieveAction,
  setSelfonboardingRetrieveAction,
  setSelfonboardingRetrieveResponse
} from "../../../Redux/Slice";
import {
  updateBasicField,
  setBasicImage,
  selectEmployeeInformation
} from "../../../Redux/employeeInformationSlice";
import { selfOnboardDataFetchApi, basicFormApi, basicFormPostApi, addressFormApi, addressFormPostApi, idVerificationFormApi, idVerificationFormPostApi, bankFormApi, bankFormPostApi, educationFormApi, educationFormPostApi, employeementFormApi, employeementFormPostApi, declarationFormApi, declarationFormPostApi, esiFormApi, esiFormPostApi } from "../../../text/apidata";
import { store } from "../../../Redux/Store.js";
import { getLoaderAction2 } from "../../../Redux/Loader2.js";
import Loader from "../../AppComponent/Loader";

const steps = Array.from({ length: 9 }, (_, index) => index + 1);

const extractBasicFormId = (details) => {
  if (!details) return null;

  const raw =
    details?.basicform_id ||
    details?.basic_form_id ||
    details?.basicform ||
    details?.basic_form ||
    details?.basic_info_id ||
    details?.basic_info ||
    details?.employeetimeline_id?.basic_form ||
    details?.employeetimeline_id?.basicform ||
    details?.employeetimeline_id?.basic_info;

  if (!raw) return null;

  if (typeof raw === "object" && raw !== null) {
    return raw.id || raw.basicform_id || raw.basic_form_id || raw._id || null;
  }

  return String(raw);
};


const formatBloodGroup = (bg) => {
  if (!bg || bg === "Select") return "";
  return bg.replace(/\s*\+VE/i, "+").replace(/\s*-VE/i, "-");
};

const formatGender = (g) => {
  if (!g) return "";
  const str = String(g).trim().toLowerCase();
  if (str === "m" || str === "male") return "Male";
  if (str === "f" || str === "female") return "Female";
  if (str === "other" || str === "o") return "Other";
  return g.charAt(0).toUpperCase() + g.slice(1);
};

const buildBasicFormPayload = (basicInformation, basicImages) => {
  const aadharFrontUrl =
    basicImages?.aadhaarFront?.s3Url ||
    basicImages?.aadhaarFront?.url ||
    "";
  const userImageUrl =
    basicImages?.profile?.s3Url ||
    basicImages?.profile?.url ||
    "";

  let identificationMarks = [];
  if (Array.isArray(basicInformation.personal_identification_mark)) {
    identificationMarks = basicInformation.personal_identification_mark;
  } else if (basicInformation.personal_identification_mark) {
    identificationMarks = [basicInformation.personal_identification_mark];
  }

  return {
    aadhar_front: aadharFrontUrl,
    user_image: userImageUrl,
    aadhar_number: String(basicInformation.aadhar_number || "").trim(),
    first_name: String(basicInformation.first_name || "").trim(),
    phone_number: String(basicInformation.phoneNum || basicInformation.phone_number || "").trim(),
    emergency_contact_number: String(basicInformation.emergency_contact_number || "").trim(),
    email_id: String(basicInformation.email_id || basicInformation.email || "").trim(),
    date_of_birth: String(basicInformation.DateofBirth || basicInformation.date_of_birth || "").trim(),
    place_of_birth: String(basicInformation.placeofBirth || basicInformation.place_of_birth || "").trim(),
    gender: formatGender(basicInformation.gender),
    blood_group: formatBloodGroup(basicInformation.blood_group),
    religion: String(basicInformation.religion || "").trim(),
    personal_identification_mark: identificationMarks,
    aadhar_front_count: Number(basicInformation.aadhar_front_count || 0),
    aadhar_count: Number(basicInformation.aadhar_count || 0),
    employee_type: basicInformation.employee_type || "",
    employee_category: basicInformation.employee_category || "",
    state: String(basicInformation.state || "").trim(),
    city: String(basicInformation.city || "").trim(),
    referral_number: String(basicInformation.referral_number || "").trim(),
  };
};

const extractAddressFormId = (d) => {
  if (!d) return null;
  const raw =
    d?.employeetimeline_id?.address_details ||
    d?.employeetimeline_id?.address_details_form ||
    d?.address_details_form?.id ||
    d?.address_details_form ||
    d?.address_details?.id ||
    d?.address_details ||
    d?.address_details_id ||
    d?.addressform_id;

  if (typeof raw === "object" && raw !== null) {
    return raw.id || raw._id || null;
  }
  return raw ? String(raw) : null;
};

const extractIdVerificationFormId = (d) => {
  if (!d) return null;
  const raw =
    d?.employeetimeline_id?.id_verification ||
    d?.employeetimeline_id?.id_verification_form ||
    d?.employeetimeline_id?.id_details_form ||
    d?.employeetimeline_id?.id_details ||
    d?.id_details_form?.id ||
    d?.id_details_form ||
    d?.id_verification?.id ||
    d?.id_verification ||
    d?.id_verification_id ||
    d?.id_details ||
    d?.idform_id ||
    d?.id_details_form_id;

  if (typeof raw === "object" && raw !== null) {
    return raw.id || raw.id_details_form || raw.id_verification || raw._id || null;
  }
  return raw ? String(raw) : null;
};

const buildAddressFormPayload = (addressDetails, addressImages, sameAsPermanent, basicInformation) => {
  const aadhaarBackUrl =
    addressImages?.aadhaarBack?.s3Url ||
    addressImages?.aadhaarBack?.url ||
    "";

  const presState = String(addressDetails.state_id || addressDetails.state_name || "").trim();
  const validPresState = (presState === "Select" || !presState) ? "" : presState;

  const permState = String(addressDetails.state_id1 || addressDetails.state_name1 || "").trim();
  const validPermState = (permState === "Select" || !permState) ? "" : permState;

  const present_address = {
    street_name: String(addressDetails.street_name || "").trim(),
    town_name: String(addressDetails.town_name || "").trim(),
    city_name: String(addressDetails.city_name || "").trim(),
    state_name: validPresState,
    pin_code: String(addressDetails.pin_code || "").trim(),
  };

  const permanent_address = Boolean(sameAsPermanent)
    ? { ...present_address }
    : {
      street_name: String(addressDetails.street_name1 || "").trim(),
      town_name: String(addressDetails.town_name1 || "").trim(),
      city_name: String(addressDetails.city_name1 || "").trim(),
      state_name: validPermState,
      pin_code: String(addressDetails.pin_code1 || "").trim(),
    };

  return {
    present_address,
    permanent_address,
    is_permanent: Boolean(sameAsPermanent),
    aadhar_back_count: Number(addressDetails.aadhar_back_count || addressDetails.aadhar_count || 1),
    aadhar_number: String(addressDetails.aadhar_number || basicInformation?.aadhar_number || "").trim(),
    aadhar_back: aadhaarBackUrl,
  };
};

const buildIdVerificationFormPayload = (idVerification, idVerificationImages, basicInformation, basicImages, addressImages) => {
  const panUrl =
    idVerificationImages?.pan?.s3Url ||
    idVerificationImages?.pan?.url ||
    idVerification?.pan_id ||
    idVerification?.pan ||
    "";

  const aadharFrontUrl =
    basicImages?.aadhaarFront?.s3Url ||
    basicImages?.aadhaarFront?.url ||
    basicInformation?.aadhar_front ||
    "";

  const aadharBackUrl =
    addressImages?.aadhaarBack?.s3Url ||
    addressImages?.aadhaarBack?.url ||
    "";

  return {
    aadhar_number: String(basicInformation?.aadhar_number || "").replace(/\D/g, ""),
    pan_number: String(idVerification?.pan_number || "").trim().toUpperCase(),
    is_id_verification: Boolean(idVerification?.is_id_verification || idVerification?.pan_verified || false),
    pan_front_count: Number(idVerification?.pan_front_count || idVerification?.pan_count || 1),
    aadhar_pan_linked: Boolean(idVerification?.aadhar_pan_linked || false),
    pan_verify_count: Number(idVerification?.pan_verify_count || 0),
    pan_verified: Boolean(idVerification?.pan_verified || false),
    pan: panUrl,
    aadhar_front: aadharFrontUrl,
    aadhar_back: aadharBackUrl,
    is_id_verification: true
  };
};

const extractBankFormId = (details) => {
  if (!details) return null;
  const raw =
    details?.employeetimeline_id?.bank_details ||
    details?.employeetimeline_id?.bank_details_form ||
    details?.bank_details_form?.id ||
    details?.bank_details_form ||
    details?.bank_details_id ||
    details?.bank_details ||
    details?.bankform_id;

  if (typeof raw === "object" && raw !== null) {
    return raw.id || raw._id || null;
  }
  return raw ? String(raw) : null;
};

const buildBankFormPayload = (bankDetails, bankImages) => {
  const bankUrl =
    bankImages?.document?.s3Url ||
    bankImages?.document?.url ||
    bankDetails?.bank_id ||
    bankDetails?.bank ||
    "";

  return {
    account_number: String(bankDetails?.account_number || "").trim(),
    bank_branch: String(bankDetails?.bank_branch || "").trim().toUpperCase(),
    ifsc_code: String(bankDetails?.ifsc_code || "").trim().toUpperCase(),
    bank_name: String(bankDetails?.bank_name || "").trim().toUpperCase(),
    account_holder_name: String(bankDetails?.account_holder_name || "").trim().toUpperCase(),
    bank_transaction_id: String(bankDetails?.bank_transaction_id || "").trim(),
    account_exists: Boolean(bankDetails?.account_exists || false),
    bank_count: Number(bankDetails?.bank_count || 1),
    bank: bankUrl,
    remarks: String(bankDetails?.remarks || "yes").trim(),
  };
};

const extractEducationFormId = (details) => {
  if (!details) return null;
  const raw =
    details?.employeetimeline_id?.education_details ||
    details?.employeetimeline_id?.education_details_form ||
    details?.education_details_form?.id ||
    details?.education_details_form ||
    details?.education_details_id ||
    details?.education_details ||
    details?.educationform_id;

  if (typeof raw === "object" && raw !== null) {
    return raw.id || raw._id || null;
  }
  return raw ? String(raw) : null;
};

const buildEducationFormPayload = (educationDetails, educationImages, educationSkipped) => {
  const skipped = Boolean(
    educationSkipped || educationDetails?.educationSkipped || false
  );

  if (skipped) {
    return {
      not_studied: true,
      sslc_school_name: "",
      sslc_school_place: "",
      sslc_year_of_passing: "",
      hsc_school_name: "",
      hsc_school_place: "",
      hsc_year_of_passing: "",
      ug_school_name: "",
      ug_school_place: "",
      ug_year_of_passing: "",
      ug_course_name: "",
      ug_branch_name: "",
      diploma_school_name: "",
      diploma_school_place: "",
      diploma_year_of_passing: "",
      diploma_branch_name: "",
      diploma_course_name: "",
      pg_school_name: "",
      pg_school_place: "",
      pg_branch_name: "",
      pg_course_name: "",
      pg_year_of_passing: "",
      school_name: "",
      standard: "",
      school_place: "",
      year_of_passing: "",
      iti_school_name: "",
      iti_school_place: "",
      iti_year_of_passing: "",
      iti_course_name: "",
      iti_branch_name: "",
      sslc_id: "",
      hsc_id: "",
      diploma_id: "",
      ug_id: "",
      pg_id: "",
      iti_id: "",
    };
  }

  const entries = educationDetails?.entries || [];

  const getEntry = (type) => entries.find((e) => e.type === type) || {};

  const getEntryImgUrl = (type) => {
    const entry = getEntry(type);
    if (!entry.id) return "";
    const imgObj = educationImages?.[entry.id];
    return imgObj?.s3Url || imgObj?.url || "";
  };

  const sslc = getEntry("10th");
  const hsc = getEntry("12th");
  const ug = getEntry("UG");
  const pg = getEntry("PG");
  const diploma = getEntry("Diploma");
  const iti = getEntry("ITI");
  const other = getEntry("OTHER");

  return {
    not_studied: false,
    sslc_school_name: String(sslc.school_name || "").trim(),
    sslc_school_place: String(sslc.school_place || "").trim(),
    sslc_year_of_passing: String(sslc.year_of_passing || "").trim(),

    hsc_school_name: String(hsc.school_name || "").trim(),
    hsc_school_place: String(hsc.school_place || "").trim(),
    hsc_year_of_passing: String(hsc.year_of_passing || "").trim(),

    ug_school_name: String(ug.school_name || "").trim(),
    ug_school_place: String(ug.school_place || "").trim(),
    ug_year_of_passing: String(ug.year_of_passing || "").trim(),
    ug_course_name: String(ug.course_name || "").trim(),
    ug_branch_name: String(ug.branch_name || "").trim(),

    diploma_school_name: String(diploma.school_name || "").trim(),
    diploma_school_place: String(diploma.school_place || "").trim(),
    diploma_year_of_passing: String(diploma.year_of_passing || "").trim(),
    diploma_branch_name: String(diploma.branch_name || "").trim(),
    diploma_course_name: String(diploma.course_name || "").trim(),

    pg_school_name: String(pg.school_name || "").trim(),
    pg_school_place: String(pg.school_place || "").trim(),
    pg_branch_name: String(pg.branch_name || "").trim(),
    pg_course_name: String(pg.course_name || "").trim(),
    pg_year_of_passing: String(pg.year_of_passing || "").trim(),

    school_name: String(other.school_name || "").trim(),
    standard: String(other.standard || "").trim(),
    school_place: String(other.school_place || "").trim(),
    year_of_passing: String(other.year_of_passing || "").trim(),

    iti_school_name: String(iti.school_name || "").trim(),
    iti_school_place: String(iti.school_place || "").trim(),
    iti_year_of_passing: String(iti.year_of_passing || "").trim(),
    iti_course_name: String(iti.course_name || "").trim(),
    iti_branch_name: String(iti.branch_name || "").trim(),

    sslc_id: getEntryImgUrl("10th"),
    hsc_id: getEntryImgUrl("12th"),
    diploma_id: getEntryImgUrl("Diploma"),
    ug_id: getEntryImgUrl("UG"),
    pg_id: getEntryImgUrl("PG"),
    iti_id: getEntryImgUrl("ITI"),
  };
};

const extractEmploymentFormId = (details) => {
  if (!details) return null;
  const raw =
    details?.employeetimeline_id?.employee_previous ||
    details?.employeetimeline_id?.previous_details_form ||
    details?.previous_details_form?.id ||
    details?.previous_details_form ||
    details?.previous_details_id ||
    details?.previous_details ||
    details?.employee_previous;

  if (typeof raw === "object" && raw !== null) {
    return raw.id || raw._id || null;
  }
  return raw ? String(raw) : null;
};

const buildEmploymentFormPayload = (previousEmploymentDetails, previousEmploymentImages) => {
  const isFresher = Boolean(previousEmploymentDetails?.isFresher);
  const entries = previousEmploymentDetails?.entries || [];

  if (isFresher) {
    return {
      data: [
        {
          company_name: "",
          designation: "",
          is_fresher: true,
          start_date: null,
          end_date: null,
          years_of_experience: "",
          month_of_experience: "",
          certificate: "",
        },
      ],
    };
  }

  const dataPayload = entries.map((entry) => {
    const certUrl =
      previousEmploymentImages?.[entry.id]?.s3Url ||
      previousEmploymentImages?.[entry.id]?.url ||
      entry.certificate ||
      "";

    return {
      company_name: String(entry.company_name || "").trim(),
      start_date: entry.start_date || null,
      end_date: entry.end_date || null,
      years_of_experience: String(entry.years_of_experience || "").trim(),
      month_of_experience: String(entry.month_of_experience || "").trim(),
      designation: String(entry.designation || "").trim(),
      certificate: certUrl,
      is_fresher: false,
    };
  });

  return {
    data: dataPayload,
  };
};

const extractDeclarationFormId = (details) => {
  if (!details) return null;
  const raw =
    details?.employeetimeline_id?.declaration_form ||
    details?.employeetimeline_id?.declaration_details_form ||
    details?.declaration_details_form?.id ||
    details?.declaration_details_form ||
    details?.declaration_form_id ||
    details?.declaration_form ||
    details?.declarationform_id;

  if (typeof raw === "object" && raw !== null) {
    return raw.id || raw._id || null;
  }
  return raw ? String(raw) : null;
};

const buildDeclarationFormPayload = (declarationDetails, declarationImages, basicInformation, bankDetails, idVerification) => {
  const passportUrl =
    declarationImages?.passport?.s3Url ||
    declarationImages?.passport?.url ||
    declarationDetails?.passport ||
    "";

  const uan = String(declarationDetails.universal_acc_number || declarationDetails.uan || "").trim();

  return {
    employee_name: String(basicInformation?.first_name || basicInformation?.name || "").trim().toUpperCase(),
    spouse_name: String(declarationDetails.spouse_name || "").trim(),
    email: String(declarationDetails.email || declarationDetails.email_id || basicInformation?.email_id || "").trim(),
    mobile_no: String(basicInformation?.phoneNum || basicInformation?.phone_number || declarationDetails.mobile_no || "").trim(),
    gender: String(basicInformation?.gender || declarationDetails.gender || "").trim(),
    marital_status: String(declarationDetails.marital_status || "unmarried").trim().toLowerCase(),
    aadhar_number: String(basicInformation?.aadhar_number || declarationDetails.aadhar_number || "").trim(),
    bank_acc_ifsc: String(bankDetails?.account_number || declarationDetails.bank_acc_ifsc || "").trim(),
    date_of_birth: String(basicInformation?.DateofBirth || basicInformation?.date_of_birth || declarationDetails.date_of_birth || "").trim(),
    pan_number: String(idVerification?.pan_number || declarationDetails.pan_number || "").trim().toUpperCase(),
    origin_country: declarationDetails.is_international
      ? String(declarationDetails.origin_country || declarationDetails.country_of_origin || "").trim().toUpperCase()
      : "",
    passport_number: declarationDetails.is_international
      ? String(declarationDetails.passport_number || "").trim().toUpperCase()
      : "",
    passport_validity_from: declarationDetails.is_international
      ? declarationDetails.passport_validity_from || null
      : null,
    passport_validity_to: declarationDetails.is_international
      ? declarationDetails.passport_validity_to || null
      : null,
    pf_acc_number: String(declarationDetails.pf_acc_number || declarationDetails.previous_pf || "").trim(),
    previous_end_date: declarationDetails.previous_end_date || declarationDetails.exit_date || null,
    universal_acc_number: uan,
    ppo_number: String(declarationDetails.ppo_number || "").trim(),
    scheme_number: String(declarationDetails.scheme_number || declarationDetails.scheme_certificate || "").trim(),
    is_international: Boolean(declarationDetails.is_international),
    relation: String(declarationDetails.relation || declarationDetails.family_member || "").trim().toUpperCase(),
    relation_name: String(declarationDetails.relation_name || declarationDetails.person_name || "").trim().toUpperCase(),
    pension_schema: Boolean(declarationDetails.pension_schema),
    provident_fund_schema: Boolean(declarationDetails.provident_fund_schema),
    ifsc_code: String(bankDetails?.ifsc_code || declarationDetails.ifsc_code || "").trim().toUpperCase(),
    passport: passportUrl,
    is_uan_number: uan ? true : Boolean(declarationDetails.is_uan_number),
  };
};

const extractEsiFormId = (details) => {
  if (!details) return null;
  const raw =
    details?.employeetimeline_id?.esi_form ||
    details?.employeetimeline_id?.esi_details_form ||
    details?.esi_details_form?.id ||
    details?.esi_details_form ||
    details?.esi_form_id ||
    details?.esi_form ||
    details?.esiform_id;

  if (typeof raw === "object" && raw !== null) {
    return raw.id || raw._id || null;
  }
  return raw ? String(raw) : null;
};

const buildEsiFormPayload = (esiDetails, basicInformation, addressDetails, bankDetails, timelineId) => {
  const nominees = esiDetails?.nominees || [];

  const getNomData = (index) => {
    const n = nominees[index];
    if (!n || (!n.name && !n.address && !n.relationship && !n.dob && !n.image)) {
      return {
        name_address: null,
        relationship: null,
        dob: null,
        minor: null,
        percentage: null,
        total_amount: null,
        image: null,
      };
    }
    const nameStr = String(n.name || "").trim().toUpperCase();
    const addrStr = String(n.address || "").trim().toUpperCase();
    const formattedNameAddr = `${nameStr}@@@@####@@@@ ${addrStr}`;
    const imgUrl = n.image?.s3Url || n.image?.url || (typeof n.image === "string" ? n.image : null) || null;

    return {
      name_address: formattedNameAddr,
      relationship: n.relationship ? String(n.relationship).trim().toUpperCase() : null,
      dob: n.dob || null,
      minor: n.guardian ? String(n.guardian).trim() : null,
      percentage: n.share ? String(n.share).trim() : "0",
      total_amount: "0",
      image: imgUrl,
    };
  };

  const nom1 = getNomData(0);
  const nom2 = getNomData(1);
  const nom3 = getNomData(2);
  const nom4 = getNomData(3);

  const fatherHusbandRel = String(esiDetails.NameOfFamliy || "father").trim().toLowerCase();
  const fatherHusbandVal = String(esiDetails.FatherORHUSBANDNAME || "").trim();
  const combinedFatherHusband = fatherHusbandVal
    ? `${fatherHusbandVal}@@@@####@@@@${fatherHusbandRel}`
    : "";

  const permAddrStr = [
    addressDetails?.permanentStreet || addressDetails?.street_name1,
    addressDetails?.permanentCity || addressDetails?.city_name1,
    addressDetails?.permanentTown || addressDetails?.town_name1,
    addressDetails?.permanentPinCode || addressDetails?.pin_code1,
  ]
    .filter(Boolean)
    .join(",");

  const tempAddrStr = [
    addressDetails?.street_name,
    addressDetails?.city_name,
    addressDetails?.town_name,
    addressDetails?.pin_code,
  ]
    .filter(Boolean)
    .join(",");

  return {
    timeline_id: timelineId || esiDetails.timeline_id || "",
    employee_name: String(basicInformation?.first_name || "").trim(),
    marital_status: String(esiDetails.marital_status || "unmarried").trim().toLowerCase(),
    father_husband_name: combinedFatherHusband || fatherHusbandVal,
    gender: String(esiDetails.gender || basicInformation?.gender || "Male").trim(),
    date_of_joining: esiDetails.date_of_joining || null,
    date_of_birth: basicInformation?.DateofBirth || basicInformation?.date_of_birth || null,
    e_p_f: String(esiDetails.e_p_f || "").trim(),
    e_p_s: String(esiDetails.e_p_s || "").trim(),
    address_temporary: tempAddrStr || permAddrStr || esiDetails.address_temporary || "",
    address_permanent: permAddrStr || tempAddrStr || esiDetails.address_permanent || "",
    account_number: String(bankDetails?.account_number || esiDetails.account_number || "").trim(),
    total_amount: "0",
    esi_dispensary: String(esiDetails.esi_dispensary || "").trim(),
    previous_ESI_number: String(esiDetails.previous_ESI_number || "").trim(),
    // esi_id_card: esiDetails.esi_id_card || "", // ESI ID card hidden in self onboarding
    contract_duration: "",
    contract_end_date: "",
    attendance_cycle: "",
    notice_period: "",

    // Nominee 1
    nominee_name_address: nom1.name_address,
    nominee_relationship: nom1.relationship,
    nominee_dob: nom1.dob,
    if_nominee_minor: nom1.minor,
    percentage: nom1.percentage,
    nominee_image: nom1.image,

    // Nominee 2
    second_nominee_name_address: nom2.name_address,
    second_nominee_relationship: nom2.relationship,
    second_nominee_dob: nom2.dob,
    second_if_nominee_minor: nom2.minor,
    second_percentage: nom2.percentage,
    second_total_amount: nom2.total_amount,
    second_nominee_image: nom2.image,

    // Nominee 3
    third_nominee_name_address: nom3.name_address,
    third_nominee_relationship: nom3.relationship,
    third_nominee_dob: nom3.dob,
    third_if_nominee_minor: nom3.minor,
    third_percentage: nom3.percentage,
    third_total_amount: nom3.total_amount,
    third_nominee_image: nom3.image,

    // Nominee 4
    fourth_nominee_name_address: nom4.name_address,
    fourth_nominee_relationship: nom4.relationship,
    fourth_nominee_dob: nom4.dob,
    fourth_if_nominee_minor: nom4.minor,
    fourth_percentage: nom4.percentage,
    fourth_total_amount: nom4.total_amount,
    fourth_nominee_image: nom4.image,
  };
};

export default function PageShell({ onPrevious = () => { } }) {
  const { retriveId } = useParams()
  const esignatureId = "1030123";

  const dispatch = useDispatch();
  const employeeDetails = useSelector(
    (state) =>
      state.Signature_Employee_RetrieveCall_actions?.Signature_Employee_Datas,
  );
  const retrieveError = useSelector(
    (state) => state.Signature_Employee_RetrieveCall_actions?.Error,
  );
  const selfonboardData = useSelector(
    (state) => state.selfonboardingretriveslice?.Selfonboarding_Data,
  );
  const selfonboardError = useSelector(
    (state) => state.selfonboardingretriveslice?.Error,
  );

  const { basicInformation, basicImages, addressDetails, addressImages, sameAsPermanent, idVerification, idVerificationImages, bankDetails, bankImages, educationDetails, educationImages, previousEmploymentDetails, previousEmploymentImages, declarationDetails, declarationImages, esiDetails, educationSkipped } = useSelector(
    selectEmployeeInformation
  );
  const LoaderData2 = useSelector((state) => state.Loader2);

  const fetchedBasicFormIdRef = useRef(null);
  console.log(LoaderData2, "LoaderData2");


  const [dataFetchData, setDataFetchData] = useState(null);

  const getSessionToken = (details) => {
    return (
      store?.getState()?.users?.UserData?.session?.token ||
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      selfonboardData?.session_token ||
      selfonboardData?.token ||
      selfonboardData?.sessionToken ||
      employeeDetails?.session_token ||
      employeeDetails?.token ||
      employeeDetails?.sessionToken ||
      localStorage.getItem("token") ||
      localStorage.getItem("session_token") ||
      ""
    );
  };

  useEffect(() => {
    if (retriveId) {
      dispatch(setSelfonboardingRetrieveAction({ retrieveId: retriveId }));
    }
  }, [dispatch, retriveId]);

  const [activeStep, setActiveStep] = useState(1);

  const refreshRetrieveData = () => {
    if (retriveId) {
      dispatch(setSelfonboardingRetrieveAction({ retrieveId: retriveId }));
    }
  };
  const basicInformationRef = useRef(null);
  const addressDetailsRef = useRef(null);
  const jobInformationRef = useRef(null);
  const idVerificationRef = useRef(null);
  const bankDetailsRef = useRef(null);
  //   const educationRef = useRef(null);
  const educationDetailsRef = useRef(null);
  const previousEmploymentDetailsRef = useRef(null);
  const declarationformRef = useRef(null);
  const esiRef = useRef(null);
  const hasPrefilledRef = useRef(false);
  const hasRedirectedRef = useRef(false);
  // const [activeStep, setActiveStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [toast, setToast] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isFormSubmittedModalOpen, setIsFormSubmittedModalOpen] = useState(false);

  useEffect(() => {
    dispatch(getLoaderAction2(false));
    const timer = setTimeout(() => {
      dispatch(getLoaderAction2(false));
    }, 400);
    return () => clearTimeout(timer);
  }, [dispatch, activeStep]);

  // useEffect(() => {
  //   if (esignatureId) {
  //     dispatch(
  //       setSignatureEmployeeRetrieveAction({ timeline_id: esignatureId }),
  //     );
  //   }
  // }, [dispatch, esignatureId]);

  useEffect(() => {
    const details = dataFetchData || selfonboardData || employeeDetails;
    if (!details) {
      return;
    }

    const basicFieldMap = {
      first_name:
        details?.first_name ||
        details?.name ||
        details?.user_id__first_name ||
        details?.user__first_name ||
        details?.basic_info?.first_name ||
        "",

      phoneNum:
        details?.phone_number ||
        details?.phoneNum ||
        details?.user_id__phone_number ||
        details?.mobile_number ||
        details?.basic_info?.phone_number ||
        "",

      email_id:
        details?.email_id ||
        details?.email ||
        details?.user_id__email ||
        details?.basic_info?.email_id ||
        "",

      aadhar_number:
        details?.aadhar_number ||
        details?.aadhaar_number ||
        details?.basic_info?.aadhar_number ||
        "",

      DateofBirth: (details?.date_of_birth || details?.dob || details?.DateofBirth || details?.basic_info?.date_of_birth) &&
        !/^\d{4}$/.test(String(details?.date_of_birth || details?.dob || details?.DateofBirth || details?.basic_info?.date_of_birth).trim())
        ? String(details?.date_of_birth || details?.dob || details?.DateofBirth || details?.basic_info?.date_of_birth).trim()
        : "",

      placeofBirth:
        details?.place_of_birth ||
        details?.placeofBirth ||
        details?.basic_info?.place_of_birth ||
        "",

      gender:
        details?.gender ||
        details?.basic_info?.gender ||
        "",

      blood_group:
        details?.blood_group ||
        details?.bloodGroup ||
        details?.blood_group_name ||
        details?.basic_info?.blood_group ||
        "",

      employee_type:
        details?.employee_type ??
        details?.basic_info?.employee_type ??
        details?.user_id__employee_type ??
        "",

      employee_category:
        details?.employee_category ??
        details?.basic_info?.employee_category ??
        details?.user_id__employee_category ??
        "",

      state:
        details?.state ||
        details?.basic_info?.state ||
        "",

      city:
        details?.city ||
        details?.basic_info?.city ||
        "",

      referral_number:
        details?.referral_number ||
        details?.basic_info?.referral_number ||
        "",
    };

    Object.entries(basicFieldMap).forEach(([name, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        dispatch(updateBasicField({ name, value }));
      }
    });

    if (details?.aadhar_front || details?.user_image) {
      if (details.aadhar_front) {
        const url = typeof details.aadhar_front === "object" ? details.aadhar_front.media_url || details.aadhar_front.url : details.aadhar_front;
        if (url) dispatch(setBasicImage({ name: "aadhaarFront", image: { name: "Aadhaar Front", url, s3Url: url } }));
      }
      if (details.user_image) {
        const url = typeof details.user_image === "object" ? details.user_image.media_url || details.user_image.url : details.user_image;
        if (url) dispatch(setBasicImage({ name: "profile", image: { name: "Profile", url, s3Url: url } }));
      }
    }

    hasPrefilledRef.current = true;
  }, [dispatch, dataFetchData, selfonboardData, employeeDetails]);

  useEffect(() => {
    const details = dataFetchData || selfonboardData || employeeDetails;
    if (!details) return;

    if (!hasRedirectedRef.current) {
      const hasVal = (val) => val !== null && val !== undefined && val !== "" && String(val) !== "null" && String(val) !== "undefined";
      const isStepCompleted = (isInfo, infoVal) => {
        const isTrue = isInfo === true || String(isInfo) === "true" || String(isInfo) === "1";
        return isTrue && hasVal(infoVal);
      };

      const completed = [];
      if (isStepCompleted(details?.employeetimeline_id?.is_basic_info, details?.employeetimeline_id?.basic_info)) completed.push(1);
      if (isStepCompleted(details?.employeetimeline_id?.is_address_details, details?.employeetimeline_id?.address_details)) completed.push(2);
      if (isStepCompleted(details?.employeetimeline_id?.is_id_verification, details?.employeetimeline_id?.id_verification)) completed.push(3);
      if (isStepCompleted(details?.employeetimeline_id?.is_bank_details, details?.employeetimeline_id?.bank_details)) completed.push(4);
      if (isStepCompleted(details?.employeetimeline_id?.is_education_details, details?.employeetimeline_id?.education_details)) completed.push(5);
      if (isStepCompleted(details?.employeetimeline_id?.is_previous_employee, details?.employeetimeline_id?.employee_previous)) completed.push(6);
      if (isStepCompleted(details?.employeetimeline_id?.is_declaration_form, details?.employeetimeline_id?.declaration_form)) completed.push(7);

      const esiFormVal = extractEsiFormId(details) || details?.employeetimeline_id?.esi_form;
      if (hasVal(esiFormVal)) completed.push(8);

      setCompletedSteps(completed);

      let firstPendingStep = 1;
      for (let s = 1; s <= 8; s++) {
        if (!completed.includes(s)) {
          firstPendingStep = s;
          break;
        }
      }

      if (completed.length === 8) {
        firstPendingStep = 9;
      }

      setActiveStep(firstPendingStep);
      hasRedirectedRef.current = true;
    }
  }, [dispatch, dataFetchData, selfonboardData, employeeDetails]);

  const isOfferVerified =
    employeeDetails?.whatsapp_offer_letter_verified === true ||
    String(employeeDetails?.whatsapp_offer_letter_verified) === "true" ||
    String(employeeDetails?.whatsapp_offer_letter_verified) === "1";
  const isSigned =
    isOfferVerified && String(employeeDetails?.whatsapp_sign_status) === "1";
  const isRejected = String(employeeDetails?.whatsapp_sign_status) === "2";
  const isUnsigned = String(employeeDetails?.whatsapp_sign_status) === "0";

  const showToast = (message) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 3000);
  };

  const formatMissingMessage = (title, missingFields) => {
    const visibleMissingFields = missingFields.slice(0, 4).join(", ");
    const extraCount = missingFields.length - 4;

    return `${title}: ${visibleMissingFields}${extraCount > 0 ? ` and ${extraCount} more` : ""
      }.`;
  };

  const completeBasicInformation = () => {
    const missingFields = basicInformationRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(
        formatMissingMessage("Missing Basic Information", missingFields),
      );
      return false;
    }

    setCompletedSteps((currentSteps) =>
      currentSteps.includes(1) ? currentSteps : [...currentSteps, 1],
    );
    return true;
  };

  const completeAddressDetails = () => {
    const missingFields = addressDetailsRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(formatMissingMessage("Missing Address Details", missingFields));
      return false;
    }

    setCompletedSteps((currentSteps) =>
      currentSteps.includes(2) ? currentSteps : [...currentSteps, 2],
    );
    return true;
  };

  const completeJobInformation = () => {
    const missingFields = jobInformationRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(formatMissingMessage("Missing Job Information", missingFields));
      return false;
    }

    setCompletedSteps((currentSteps) =>
      currentSteps.includes(3) ? currentSteps : [...currentSteps, 3],
    );
    return true;
  };

  const completeIdVerification = () => {
    const missingFields = idVerificationRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(formatMissingMessage("Missing ID Verification", missingFields));
      return false;
    }

    setCompletedSteps((steps) => (steps.includes(4) ? steps : [...steps, 4]));

    return true;
  };

  const completeBankDetails = () => {
    const missing = bankDetailsRef.current?.getMissingFields() || [];

    if (missing.length > 0) {
      showToast(formatMissingMessage("Missing Bank Details", missing));
      return false;
    }

    setCompletedSteps((s) => (s.includes(5) ? s : [...s, 5]));

    return true;
  };

  const completeEducationDetails = () => {
    const missingFields = educationDetailsRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(
        formatMissingMessage("Missing Education Details", missingFields),
      );
      return false;
    }

    setCompletedSteps((steps) => (steps.includes(6) ? steps : [...steps, 6]));

    return true;
  };

  const completePreviousEmploymentDetails = () => {
    const missingFields =
      previousEmploymentDetailsRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(
        formatMissingMessage(
          "Missing Previous Employment Details",
          missingFields,
        ),
      );
      return false;
    }

    setCompletedSteps((steps) => (steps.includes(7) ? steps : [...steps, 7]));

    return true;
  };

  const completeDeclarationForm = () => {
    const missingFields = declarationformRef.current?.getMissingFields() || [];

    if (missingFields.length > 0) {
      showToast(formatMissingMessage("Missing Details", missingFields));
      return false;
    }

    setCompletedSteps((steps) => (steps.includes(8) ? steps : [...steps, 8]));

    return true; // ✅ THIS WAS MISSING
  };

  const completeEsi = () => {
    const missing = esiRef.current?.getMissingFields() || [];

    if (missing.length > 0) {
      showToast(formatMissingMessage("Missing ESI Details", missing));
      return false;
    }

    setCompletedSteps((s) => (s.includes(9) ? s : [...s, 9]));

    return true;
  };

  const handleSaveContinue = async () => {
    if (activeStep === 1) {
      const isValid = completeBasicInformation();
      if (!isValid) return;

      setIsSaving(true);
      dispatch(getLoaderAction2(true));
      try {
        const details = selfonboardData || employeeDetails;
        const basicformId = extractBasicFormId(details);
        const sessionToken = details?.session_token || details?.token || details?.sessionToken;
        const headers = sessionToken
          ? {
            Authorization: String(sessionToken).startsWith("Bearer ")
              ? sessionToken
              : `Bearer ${sessionToken}`,
          }
          : {};

        const payload = buildBasicFormPayload(basicInformation, basicImages);

        if (basicformId) {
          const response = await axios.put(
            `${basicFormApi}${basicformId}/`,
            payload,
            { headers }
          );
          console.log("Basic form PUT API response:", response.data);
          refreshRetrieveData();
          setActiveStep(2);
        } else {
          const response = await axios.post(
            basicFormPostApi,
            payload,
            { headers }
          );
          console.log("Basic form POST API response:", response.data);
          refreshRetrieveData();
          setActiveStep(2);
        }
      } catch (error) {
        console.error("Error submitting basic form API:", error);
        showToast(
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to save basic information"
        );
      } finally {
        setIsSaving(false);
        dispatch(getLoaderAction2(false));
      }
      return;
    }
    console.log(activeStep, "Daskldalkdlka");
    if (activeStep === 2) {
      const missing = addressDetailsRef.current?.getMissingFields() || [];
      if (missing.length > 0) {
        showToast(formatMissingMessage("Missing Address Details", missing));
        return;
      }

      setIsSaving(true);
      dispatch(getLoaderAction2(true));
      try {
        const details = selfonboardData || employeeDetails;
        const addressFormId = extractAddressFormId(details);
        const sessionToken = details?.session_token || details?.token || details?.sessionToken;
        const headers = sessionToken
          ? {
            Authorization: String(sessionToken).startsWith("Bearer ")
              ? sessionToken
              : `Bearer ${sessionToken}`,
          }
          : {};

        const payload = buildAddressFormPayload(addressDetails, addressImages, sameAsPermanent, basicInformation);

        if (addressFormId) {
          const response = await axios.put(
            `${addressFormApi}${addressFormId}/`,
            payload,
            { headers }
          );
          console.log("Address form PUT API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(2) ? s : [...s, 2]));
          setActiveStep(3);
        } else {
          const response = await axios.post(
            addressFormPostApi,
            payload,
            { headers }
          );
          console.log("Address form POST API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(2) ? s : [...s, 2]));
          setActiveStep(3);
        }
      } catch (error) {
        console.error("Error submitting address form API:", error);
        const errMsg =
          error.response?.data?.message ||
          error.response?.data?.detail ||
          (typeof error.response?.data === "string" ? error.response.data : null) ||
          (error.response?.data ? JSON.stringify(error.response.data) : null) ||
          "Failed to save address details";
        showToast(errMsg);
        responsiveToast(errMsg, "error");
      } finally {
        setIsSaving(false);
        dispatch(getLoaderAction2(false));
      }
      return;
    }

    if (activeStep === 3) {
      const missing = idVerificationRef.current?.getMissingFields() || [];
      if (missing.length > 0) {
        showToast(formatMissingMessage("Missing ID Verification Details", missing));
        return;
      }

      setIsSaving(true);
      dispatch(getLoaderAction2(true));
      try {
        const details = selfonboardData || employeeDetails;
        const idFormId = extractIdVerificationFormId(details);
        const sessionToken = details?.session_token || details?.token || details?.sessionToken;
        const headers = sessionToken
          ? {
            Authorization: String(sessionToken).startsWith("Bearer ")
              ? sessionToken
              : `Bearer ${sessionToken}`,
          }
          : {};

        const payload = buildIdVerificationFormPayload(
          idVerification,
          idVerificationImages,
          basicInformation,
          basicImages,
          addressImages
        );

        const targetId =
          idFormId ||
          extractIdVerificationFormId(details) ||
          (typeof details?.employeetimeline_id === "object" ? details?.employeetimeline_id?.id : details?.employeetimeline_id) ||
          details?.id;

        const updateUrl = targetId
          ? `${idVerificationFormApi}${targetId}/`
          : idVerificationFormApi;

        const response = await axios.put(
          updateUrl,
          payload,
          { headers }
        );
        console.log("ID verification form PUT API response:", response.data);
        refreshRetrieveData();
        setCompletedSteps((s) => (s.includes(3) ? s : [...s, 3]));
        setActiveStep(4);
      } catch (error) {
        console.error("Error submitting ID verification form API:", error);
        showToast(
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to save ID verification details"
        );
      } finally {
        setIsSaving(false);
        dispatch(getLoaderAction2(false));
      }
      return;
    }

    if (activeStep === 4) {
      const missing = bankDetailsRef.current?.getMissingFields() || [];
      if (missing.length > 0) {
        showToast(formatMissingMessage("Missing Bank Details", missing));
        return;
      }

      setIsSaving(true);
      dispatch(getLoaderAction2(true));
      try {
        const details = selfonboardData || employeeDetails;
        const bankFormId = extractBankFormId(details);
        const sessionToken = details?.session_token || details?.token || details?.sessionToken;
        const headers = sessionToken
          ? {
            Authorization: String(sessionToken).startsWith("Bearer ")
              ? sessionToken
              : `Bearer ${sessionToken}`,
          }
          : {};

        const payload = buildBankFormPayload(bankDetails, bankImages);

        if (bankFormId) {
          const response = await axios.put(
            `${bankFormApi}${bankFormId}/`,
            payload,
            { headers }
          );
          console.log("Bank form PUT API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(4) ? s : [...s, 4]));
          setActiveStep(5);
        } else {
          const response = await axios.post(
            bankFormPostApi,
            payload,
            { headers }
          );
          console.log("Bank form POST API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(4) ? s : [...s, 4]));
          setActiveStep(5);
        }
      } catch (error) {
        console.error("Error submitting Bank form API:", error);
        showToast(
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to save Bank details"
        );
      } finally {
        setIsSaving(false);
        dispatch(getLoaderAction2(false));
      }
      return;
    }

    if (activeStep === 5) {
      const missing = educationDetailsRef.current?.getMissingFields() || [];
      if (missing.length > 0) {
        showToast(formatMissingMessage("Missing Education Details", missing));
        return;
      }

      setIsSaving(true);
      dispatch(getLoaderAction2(true));
      try {
        const details = selfonboardData || employeeDetails;
        const educationFormId = extractEducationFormId(details);
        const sessionToken = details?.session_token || details?.token || details?.sessionToken;
        const headers = sessionToken
          ? {
            Authorization: String(sessionToken).startsWith("Bearer ")
              ? sessionToken
              : `Bearer ${sessionToken}`,
          }
          : {};

        const payload = buildEducationFormPayload(educationDetails, educationImages, educationSkipped);

        if (educationFormId) {
          const response = await axios.put(
            `${educationFormApi}${educationFormId}/`,
            payload,
            { headers }
          );
          console.log("Education form PUT API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(5) ? s : [...s, 5]));
          setActiveStep(6);
        } else {
          const response = await axios.post(
            educationFormPostApi,
            payload,
            { headers }
          );
          console.log("Education form POST API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(5) ? s : [...s, 5]));
          setActiveStep(6);
        }
      } catch (error) {
        console.error("Error submitting Education form API:", error);
        showToast(
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to save Education details"
        );
      } finally {
        setIsSaving(false);
        dispatch(getLoaderAction2(false));
      }
      return;
    }
    if (activeStep === 6) {
      const missing = previousEmploymentDetailsRef.current?.getMissingFields() || [];
      if (missing.length > 0) {
        showToast(formatMissingMessage("Missing Previous Employment Details", missing));
        return;
      }

      setIsSaving(true);
      dispatch(getLoaderAction2(true));
      try {
        const details = selfonboardData || employeeDetails;
        const employmentFormId = extractEmploymentFormId(details);
        const sessionToken = details?.session_token || details?.token || details?.sessionToken;
        const headers = sessionToken
          ? {
            Authorization: String(sessionToken).startsWith("Bearer ")
              ? sessionToken
              : `Bearer ${sessionToken}`,
          }
          : {};

        const payload = buildEmploymentFormPayload(previousEmploymentDetails, previousEmploymentImages);

        if (employmentFormId) {
          const response = await axios.put(
            `${employeementFormApi}${employmentFormId}/`,
            payload,
            { headers }
          );
          console.log("Previous Employment form PUT API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(6) ? s : [...s, 6]));
          setActiveStep(7);
        } else {
          const response = await axios.post(
            employeementFormPostApi,
            payload,
            { headers }
          );
          console.log("Previous Employment form POST API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(6) ? s : [...s, 6]));
          setActiveStep(7);
        }
      } catch (error) {
        console.error("Error submitting Previous Employment form API:", error);
        showToast(
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to save Previous Employment details"
        );
      } finally {
        setIsSaving(false);
        dispatch(getLoaderAction2(false));
      }
      return;
    }
    if (activeStep === 7) {
      const missing = declarationformRef.current?.getMissingFields() || [];
      if (missing.length > 0) {
        showToast(formatMissingMessage("Missing Declaration Details", missing));
        return;
      }

      setIsSaving(true);
      dispatch(getLoaderAction2(true));
      try {
        const details = selfonboardData || employeeDetails;
        const declarationFormId = extractDeclarationFormId(details);
        const sessionToken = details?.session_token || details?.token || details?.sessionToken;
        const headers = sessionToken
          ? {
            Authorization: String(sessionToken).startsWith("Bearer ")
              ? sessionToken
              : `Bearer ${sessionToken}`,
          }
          : {};

        const payload = buildDeclarationFormPayload(
          declarationDetails,
          declarationImages,
          basicInformation,
          bankDetails,
          idVerification
        );

        if (declarationFormId) {
          const response = await axios.put(
            `${declarationFormApi}${declarationFormId}/`,
            payload,
            { headers }
          );
          console.log("Declaration form PUT API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(7) ? s : [...s, 7]));
          setActiveStep(8);
        } else {
          console.log(headers, "kdjajdkadjkad", employeeDetails, selfonboardData);
          const response = await axios.post(
            declarationFormPostApi,
            payload,
            { headers }
          );
          console.log("Declaration form POST API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(7) ? s : [...s, 7]));
          setActiveStep(8);
        }
      } catch (error) {
        console.error("Error submitting Declaration form API:", error);
        showToast(
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to save Declaration details"
        );
      } finally {
        setIsSaving(false);
        dispatch(getLoaderAction2(false));
      }
      return;
    }

    if (activeStep === 8) {
      const missing = esiRef.current?.getMissingFields() || [];
      if (missing.length > 0) {
        showToast(formatMissingMessage("Missing ESI Details", missing));
        return;
      }

      setIsSaving(true);
      dispatch(getLoaderAction2(true));
      try {
        const details = selfonboardData || employeeDetails;
        const esiFormId = extractEsiFormId(details);
        const sessionToken = details?.session_token || details?.token || details?.sessionToken;
        const headers = sessionToken
          ? {
            Authorization: String(sessionToken).startsWith("Bearer ")
              ? sessionToken
              : `Bearer ${sessionToken}`,
          }
          : {};

        const payload = buildEsiFormPayload(
          esiDetails,
          basicInformation,
          addressDetails,
          bankDetails,
          details?.employeetimeline_id?.id || details?.id || ""
        );

        if (esiFormId) {
          const response = await axios.put(
            `${esiFormApi}${esiFormId}/`,
            payload,
            { headers }
          );
          console.log("ESI form PUT API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(8) ? s : [...s, 8]));
          // showToast("ESI details saved successfully");
          setActiveStep(9);
        } else {
          const response = await axios.post(
            esiFormPostApi,
            payload,
            { headers }
          );
          console.log("ESI form POST API response:", response.data);
          refreshRetrieveData();
          setCompletedSteps((s) => (s.includes(8) ? s : [...s, 8]));
          // showToast("ESI details saved successfully");
          setActiveStep(9);
        }
      } catch (error) {
        console.error("Error submitting ESI form API:", error);
        showToast(
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to save ESI details"
        );
      } finally {
        setIsSaving(false);
        dispatch(getLoaderAction2(false));
      }
      return;
    }

    if (activeStep === 9) {
      showToast("Please verify OTP and draw your digital signature above to submit.");
      return;
    }
  };

  const handlePrevious = () => {
    if (activeStep === 1) {
      onPrevious();
      return;
    }

    refreshRetrieveData();
    setActiveStep((currentStep) => currentStep - 1);
  };

  const isStepUnlocked = (targetStep) => {
    if (targetStep === 1) return true;
    if (completedSteps.includes(targetStep)) return true;

    const details = selfonboardData || employeeDetails;
    const timeline = details?.employeetimeline_id || {};

    if (targetStep === 2 && (timeline.is_basic_info || details?.basic_info || details?.basic_details)) return true;
    if (targetStep === 3 && (timeline.is_address_details || details?.address_details)) return true;
    if (targetStep === 4 && (timeline.is_id_verification || details?.id_verification)) return true;
    if (targetStep === 5 && (timeline.is_bank_details || details?.bank_details)) return true;
    if (targetStep === 6 && (timeline.is_education_details || details?.education_details)) return true;
    if (targetStep === 7 && (timeline.is_previous_employee || details?.employee_previous)) return true;
    if (targetStep === 8 && (timeline.is_declaration_form || details?.declaration_form)) return true;

    return false;
  };

  const handleTimelineClick = (step) => {
    if (step === activeStep) return;

    if (step < activeStep || isStepUnlocked(step)) {
      refreshRetrieveData();
      setActiveStep(step);
      return;
    }

    if (step === activeStep + 1) {
      if (activeStep === 1) {
        const missing = basicInformationRef.current?.getMissingFields() || [];
        if (missing.length > 0) {
          showToast(formatMissingMessage("Missing Basic Information", missing));
          return;
        }
      } else if (activeStep === 2) {
        const missing = addressDetailsRef.current?.getMissingFields() || [];
        if (missing.length > 0) {
          showToast(formatMissingMessage("Missing Address Details", missing));
          return;
        }
      } else if (activeStep === 3) {
        const missing = idVerificationRef.current?.getMissingFields() || [];
        if (missing.length > 0) {
          showToast(formatMissingMessage("Missing ID Verification Details", missing));
          return;
        }
      } else if (activeStep === 4) {
        const missing = bankDetailsRef.current?.getMissingFields() || [];
        if (missing.length > 0) {
          showToast(formatMissingMessage("Missing Bank Details", missing));
          return;
        }
      } else if (activeStep === 5) {
        const missing = educationDetailsRef.current?.getMissingFields() || [];
        if (missing.length > 0) {
          showToast(formatMissingMessage("Missing Education Details", missing));
          return;
        }
      } else if (activeStep === 6) {
        const missing = previousEmploymentDetailsRef.current?.getMissingFields() || [];
        if (missing.length > 0) {
          showToast(formatMissingMessage("Missing Previous Employment Details", missing));
          return;
        }
      } else if (activeStep === 7) {
        const missing = declarationformRef.current?.getMissingFields() || [];
        if (missing.length > 0) {
          showToast(formatMissingMessage("Missing Declaration Details", missing));
          return;
        }
      } else if (activeStep === 8) {
        const missing = esiRef.current?.getMissingFields() || [];
        if (missing.length > 0) {
          showToast(formatMissingMessage("Missing ESI Details", missing));
          return;
        }
      }

      setCompletedSteps((s) => (s.includes(activeStep) ? s : [...s, activeStep]));
      refreshRetrieveData();
      setActiveStep(step);
    }
  };

  const renderActiveStep = () => {
    if (activeStep === 1) {
      return <BasicInformation ref={basicInformationRef} />;
    }

    if (activeStep === 2) {
      return <AddressDetails ref={addressDetailsRef} />;
    }

    // if (activeStep === 3) {
    //   return <JobInformation ref={jobInformationRef} />;
    // }

    if (activeStep === 3) {
      return <IdVerification ref={idVerificationRef} />;
    }

    if (activeStep === 4) {
      return <BankDetails ref={bankDetailsRef} />;
    }

    if (activeStep === 5) {
      return <EducationDetails ref={educationDetailsRef} />;
    }

    if (activeStep === 6) {
      return <PreviousEmploymentDetails ref={previousEmploymentDetailsRef} />;
    }
    if (activeStep === 7) {
      return <DeclarationForm ref={declarationformRef} />;
    }

    if (activeStep === 8) {
      return <EsiForm ref={esiRef} />;
    }

    if (activeStep === 9) {
      return (
        <SubmissionForm
          phoneNumber={details?.phone_number || details?.mobile_number || basicInformation?.phoneNum || ""}
          timelineId={details?.employeetimeline_id?.id || details?.employeetimeline_id || ""}
          sessionToken={details?.session_token || details?.token || ""}
          onSuccess={() => {
            setIsFormSubmittedModalOpen(true);
            refreshRetrieveData();
          }}
          showToast={showToast}
        />
      );
    }
    // if (activeStep === 10) {
    //   return <ReviewPage onEdit={handleEditFromReview} />;
    // }

    return (
      <div className={styles.stepPlaceholder}>
        <h2>Step {activeStep}</h2>
      </div>
    );
  };

  const details = selfonboardData || employeeDetails;

  if (retriveId && !details && !selfonboardError && !retrieveError) {
    return (
      <main className={styles.pageShell}>
        <Loader />
      </main>
    );
  }

  if (retriveId && (selfonboardError || retrieveError || !details)) {
    return (
      <main className={styles.pageShell} style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", padding: "20px" }}>
        <section className={styles.statusPanel} style={{ margin: "auto", textAlign: "center", padding: "36px 24px", maxWidth: "480px", width: "100%", background: "#ffffff", borderRadius: "16px", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)" }}>
          <h1 style={{ fontSize: "22px", color: "#ef4444", fontWeight: "700", marginBottom: "10px" }}>Invalid Onboarding Link</h1>
          <p style={{ color: "#64748b", fontSize: "15px" }}>We could not verify this onboarding link. Please contact your administrator.</p>
        </section>
      </main>
    );
  }

  if (selfonboardData?.link_expired === true || selfonboardData?.link_expired === "True") {
    return (
      <main className={styles.pageShell} style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", padding: "20px" }}>
        <section className={styles.statusPanel} style={{ margin: "auto", textAlign: "center", padding: "36px 24px", maxWidth: "480px", width: "100%", background: "#ffffff", borderRadius: "16px", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)" }}>
          <h1 style={{ fontSize: "22px", color: "#f59e0b", fontWeight: "700", marginBottom: "10px" }}>Link Expired</h1>
          <p style={{ color: "#64748b", fontSize: "15px" }}>This onboarding link has expired. Please contact Administrator to generate a new invitation link.</p>
        </section>
      </main>
    );
  }

  const isAlreadySubmitted =
    details?.employeetimeline_id?.create_employee === true ||
    String(details?.employeetimeline_id?.create_employee) === "true" ||
    isFormSubmittedModalOpen;

  return (
    <main className={styles.pageShell}>
      {toast ? <div className={styles.toast}>{toast}</div> : null}

      {isAlreadySubmitted && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(15, 23, 42, 0.8)",
            zIndex: 999999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(4px)",
            overflow: "hidden"
          }}
        >
          <div
            style={{
              background: "#ffffff",
              padding: "40px 32px",
              borderRadius: "16px",
              maxWidth: "480px",
              width: "90%",
              textAlign: "center",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            }}
          >
            <div
              style={{
                width: "72px",
                height: "72px",
                background: "#dcfce7",
                color: "#16a34a",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "36px",
                margin: "0 auto 20px",
                fontWeight: "bold",
              }}
            >
              ✓
            </div>
            <h2 style={{ fontSize: "22px", fontWeight: "800", color: "#0f172a", marginBottom: "12px" }}>
              Form Submitted Successfully
            </h2>
            <p style={{ fontSize: "15px", color: "#475569", lineHeight: "1.6", marginBottom: "24px" }}>
              Your onboarding form details and digital signature have been submitted successfully.
            </p>
            <div style={{ fontSize: "13px", color: "#94a3b8", fontWeight: "500" }}>
              Thank you! You may close this browser tab.
            </div>
          </div>
        </div>
      )}
      {/* <img className={styles.logo} src={udsLogo} alt="UDS" />
      <h1 className={styles.pageTitle}>Employee Information Form</h1> */}

      <div className={styles.pageHeader}>
        {/* <img className={styles.logo} src={udsLogo} alt="UDS" /> */}
        <h1 className={styles.pageTitle}>Employee Information Form</h1>
      </div>
      <div className={styles.shellWrap}>
        {/* <h1 className={styles.pageTitle}>Employee Form Information</h1> */}

        <div className={styles.timelineWrap}>
          <nav className={styles.timeline} aria-label="Onboarding progress">
            {steps.map((step) => (
              <div
                className={[
                  styles.timelineItem,
                  completedSteps.includes(step)
                    ? styles.completedConnector
                    : "",
                ].join(" ")}
                key={step}
              >
                <button
                  className={[
                    styles.timelineStep,
                    step === activeStep ? styles.activeStep : "",
                    completedSteps.includes(step) ? styles.completedStep : "",
                  ].join(" ")}
                  type="button"
                  onClick={() => handleTimelineClick(step)}
                >
                  {step}
                </button>
              </div>
            ))}
          </nav>
        </div>

        <section className={styles.shellCard}>
          <section className={styles.heroSection} aria-label="Page content">
            {renderActiveStep()}
          </section>

          <footer className={styles.footerActions}>
            {activeStep > 1 ? (
              <button
                className={styles.previousButton}
                type="button"
                onClick={handlePrevious}
              >
                Previous
              </button>
            ) : null}
            {activeStep < 9 && (
              <button
                className={styles.continueButton}
                type="button"
                disabled={isSaving}
                onClick={handleSaveContinue}
                style={{
                  opacity: isSaving ? 0.75 : 1,
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                    <span className={styles.spinner} />
                    Saving...
                  </span>
                ) : (
                  "Save and Continue"
                )}
              </button>
            )}
          </footer>
        </section>
      </div>
    </main>
  );
}
